import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

// Tab state that lives in the URL (?tab=…) so browser Back/Forward move between tabs and a
// refresh or shared link lands on the same one. Default value = param omitted.
export function useUrlTab(key, defaultValue, valid) {
  const [sp, setSp] = useSearchParams();
  const raw = sp.get(key);
  const value = raw && (!valid || valid.includes(raw)) ? raw : defaultValue;
  const setValue = useCallback((next) => {
    const v = typeof next === "function" ? next(value) : next;
    setSp((prev) => {
      const n = new URLSearchParams(prev);
      if (!v || v === defaultValue) n.delete(key); else n.set(key, v);
      return n;
    });
  }, [key, defaultValue, value, setSp]);
  return [value, setValue];
}
